import { render, staticRenderFns } from "./rectification.vue?vue&type=template&id=9664d8f2&scoped=true&"
import script from "./rectification.vue?vue&type=script&lang=js&"
export * from "./rectification.vue?vue&type=script&lang=js&"
import style0 from "./rectification.vue?vue&type=style&index=0&id=9664d8f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9664d8f2",
  null
  
)

export default component.exports